import { Wrapper } from '@american-autonomy/ag-ui';

import RateColumnPicker from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/PrescriptionSection/components/RateColumnPicker';
import WarningDialog from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/PrescriptionSection/components/WarningDialog';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const PrescriptionImportPageModals: FunctionComponent<Props> = ({
    cancelText,
    className = '',
    columnPickerHint,
    columnPickerTitle,
    columns,
    confirmText,
    isColumnPickerOpen,
    isWarningOpen,
    onCancelColumnPicker,
    onColumnSelected,
    onWarningDismiss,
    testId = TEST_ID,
    warningMessage,
    warningTitle
}) => (
    <Wrapper className={className} testId={testId}>
        <RateColumnPicker
            cancelText={cancelText}
            columns={columns}
            confirmText={confirmText}
            hint={columnPickerHint}
            isOpen={isColumnPickerOpen}
            onCancel={onCancelColumnPicker}
            onColumnSelected={onColumnSelected}
            title={columnPickerTitle}
        />

        <WarningDialog
            cancelText={cancelText}
            isOpen={isWarningOpen}
            message={warningMessage}
            onDismiss={onWarningDismiss}
            title={warningTitle}
        />
    </Wrapper>
);

export default PrescriptionImportPageModals;
